import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
if (document.querySelector('.benefits-slider')) {
    const swiper = new Swiper('.benefits-slider .swiper', {
        modules: [Navigation, Pagination, Autoplay],
        direction: 'horizontal',
        loop: true,
        // centeredSlides: true,
        centeredSlides: false,
        // slidesPerView: 1,
        slidesPerView: 1.08,
        spaceBetween: 45,
        navigation: {
            nextEl: '.swiper-next-btn',
            prevEl: '.swiper-prev-btn',
        },
        autoplay: {
            delay: 3500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
            },

            1024: {
                slidesPerView: 3,
            },
            1700: {
                slidesPerView: 5,
            },
        },
    });
    1;
}

if (document.querySelector('.technology-slider')) {
    const swiper = new Swiper('.technology-slider .swiper', {
        modules: [Navigation, Pagination, Autoplay],
        direction: 'horizontal',
        centeredSlides: false,
        loop: false,
        slidesPerView: 1.12,
        spaceBetween: 45,

        autoplay: {
            delay: 3500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
        breakpoints: {
            768: {
                slidesPerView: 2.1,
            },

            1024: {
                slidesPerView: 3.1,
            },
            1700: {
                slidesPerView: 4.1,
            },
        },
    });
    1;
}

const technologySlider = document.querySelector('.technology-slider');
if (technologySlider) {
    const slides = technologySlider.childNodes[1].childNodes[1].childNodes;
    const length = Array.from(slides).filter((slide) => slide.nodeName === 'DIV').length;
    if (length <= 3) {
        technologySlider.classList.add('remove-pointer');
    }
}
